export enum DataType {
  Users = 'users',
  Economics = 'economics'
}

export interface MRRData {
  date: string // e.g. '2025-11-01'
  data_type: DataType
  new: number // >= 0
  existing: number // >= 0
  churn: number // <= 0
  total: number
}

export interface MRRParams {
  month: string
  total_months: number
  data_type: DataType
}

export interface MRRResponse {
  data: MRRData[]
  metrics: {
    netNewMRR: number[]
    growthRate: number[]
    arr: number[]
    lifetimeValue: number[]
  }
  dataType: DataType
}
